export class Returninvoice {
    id: string;
  organization_id: string;
  branch_id: string;
  invoice_id:string;
  date_time: string;
  price_offer: string;
  customer_id: string;
  customer_type:string;
  customer_name:string;
  invoice_type:string;
  delegate_type:string;
  delegate_id:string;
  delegate_name: string;
  items_from_branch_id: string;
  type_country: string;
  row_id: string;
  time: string;
  year: any;

  total_free: string;
  customer_cash: string;
  paid: string;

  disc_type:string;
  disc_value:string;
  remain:string;
  import_date:string;

  inv_details:string;
  inv_payment_details:string;
  // cashier_operation:string
  // cashier_id:string


    last_on_behalf_of:string;
    showDeletedOnly: boolean;

    constructor() {

    }
}



// WEBPACK FOOTER //
// ./src/app/views/pos/returninvoices/returninvoices.ts